'use client'

import { useSession } from '@/shared/ui/providers/AuthSessionProvider'
import { getLandingVariant } from '@/utils/landing-variant'

export function useHomePage() {
  const { data: session } = useSession()
  const variant = getLandingVariant()

  return {
    session: session ?? undefined,
    variant,
  }
}
